import metamask from '@/assets/logo/metamask.svg';
import logium from '@/assets/logo/logium.svg';
import { ConnectorName } from '@/wallet/WalletStore.types';

export const LOGO_MAP: Record<ConnectorName, string | undefined> = {
    metamask: metamask,
    logiumWallet: logium,
};
